import { render, staticRenderFns } from "./Pagesubtitle.vue?vue&type=template&id=0111fc1e&"
import script from "./Pagesubtitle.vue?vue&type=script&lang=js&"
export * from "./Pagesubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports